export default "__VITE_ASSET__xhbx6XhB__"